import {
  PASSWORD_RECOVERY_REQUEST,
  PASSWORD_RECOVERY_SUCCESS,
  PASSWORD_RECOVERY_ERROR,
} from "./actions";

const initialState = {
  requesting: false,
  successful: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PASSWORD_RECOVERY_REQUEST:
      return {
        requesting: true,
        successful: false,
      };

    case PASSWORD_RECOVERY_SUCCESS:
      return {
        requesting: false,
        successful: true,
      };

    case PASSWORD_RECOVERY_ERROR:
      return {
        requesting: false,
        successful: false,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/password-recovery/reducer.js